import styled from 'styled-components'

export const Wrapper = styled('div')`
  position: relative;
  margin-top: 16px;

  .react-select__control {
    padding: 0;
  }

  .react-select__input-container {
    margin: 0;
  }

  .react-select__value-container {
    height: unset;
    min-height: 32px;
  }

  input {
    opacity: 1 !important;
  }
`
